import 'datatables.net-bs5';
import DataTable, {AjaxData} from "datatables.net";
import {get, init_tooltips, notifier, number_format, on, on_keyup} from "../util";
import {crafting_link, gold, nwdb_link} from "./util";
import {Order} from "datatables.net-bs5";

interface TradesAjaxData extends AjaxData {
    type : string,
    status : string,
    nw_items_id : number,
}

export default class {
    static init = () => {
        list();
        list_grouped();
    }
}

function list() {
    let table = document.querySelector('.datatable[data-table="nw_trades"]') as HTMLElement;
    if(!table) {
        return;
    }

    let order = 9;
    let datatable = new DataTable('.datatable[data-table="nw_trades"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getTrades',
            data: function (data: TradesAjaxData, settings) {
                let type = document.getElementById('filter-type') as HTMLSelectElement;
                if(type) {
                    data.type = type.value;
                }

                let status = document.getElementById('filter-status') as HTMLSelectElement;
                if(status) {
                    data.status = status.value;
                }

                let nw_items_id = table.getAttribute('data-nw_items_id');
                if(nw_items_id) {
                    data.nw_items_id = parseInt(nw_items_id);
                }

                let search = settings.oPreviousSearch.search;
                let total = document.querySelector('.js-trades-total') as HTMLElement;
                let total_fee = document.querySelector('.js-trades-total-fee') as HTMLElement;
                let total_tax = document.querySelector('.js-trades-total-tax') as HTMLElement;
                let sell = document.querySelector('.js-trades-sell') as HTMLElement;
                let sell_fee = document.querySelector('.js-trades-sell-fee') as HTMLElement;
                let sell_tax = document.querySelector('.js-trades-sell-tax') as HTMLElement;
                let buy = document.querySelector('.js-trades-buy') as HTMLElement;
                let buy_fee = document.querySelector('.js-trades-buy-fee') as HTMLElement;
                let buy_tax = document.querySelector('.js-trades-buy-tax') as HTMLElement
                if(total && total_fee && total_tax && sell && sell_fee && sell_tax && buy && buy_fee && buy_tax) {
                    get('?do=getTradesTotals', {
                        nw_items_id: parseInt(nw_items_id ?? "0"),
                        type: type ? type.value : null,
                        status: status ? status.value : null,
                        search: search
                    }, (data: any) => {
                        if(data) {
                            total.innerText = number_format(data.buy + data.sell);
                            total_fee.innerText = number_format(data.buy_fee + data.sell_fee);
                            sell.innerText = number_format(data.sell);
                            sell_fee.innerText = number_format(data.sell_fee);
                            buy.innerText = number_format(data.buy);
                            buy_fee.innerText = number_format(data.buy_fee);
                        }
                    });

                }
                return data;
            }
        },
        columns: [
            { data: null, render: function (data, type, row) {
                return `<a href="/nw/item/${data.items_id}" class="text-decoration-none"><img src="https://cdn.nwdb.info/db/images/live/v50/icons/items/resource/${data.nw_id}.png" class="img-fluid" style="width:20px" /> ${data.name}</a>` + crafting_link(data.crafting) + nwdb_link(data.nw_id);
            }},
            { data: null, render: function (data, type, row) {
                return data.type == 'sell' ? `<span class="badge text-bg-danger">Sell</span>` : `<span class="badge text-bg-success">Buy</span>`;
            }},
            { data: null, className: "text-end", render: function (data, type, row) {
                return `<span class="js-trade-amount" style="color: ` + data.completed_percent_color + `" data-id="${data.id}" data-amount="${data.amount}" data-completed="${data.completed}">${data.completed}/${data.amount}</span>`;
            }},
            { data: null, render: () => "" },
            { data: null, render: (data) => gold(data.price)},
            { data: null, className: "", render: function (data, type, row) {
                return `<span class="js-trade-fee" data-id="${data.id}" data-fee="${data.fee}" data-completed="${data.completed}">${gold(data.fee)}</span>`;
            }},
            { data: null, render: (data) => gold(data.profit,data.profit_raw_color)},
            { data: null, render: (data) => data.completed > 0 ? gold(data.profit_per,data.profit_per_raw_color) : '-'},
            { data: null, render: function(data) {
                let s = data.days > 1 ? 's' : '';
                if(data.diff == 'Completed') {
                    return `<span data-bs-toggle="tooltip" title="${data.days} day${s}" class="badge text-bg-success">Completed</span>`;
                } else if(data.diff == 'Expired') {
                    return `<span data-bs-toggle="tooltip" title="${data.days} day${s}" class="badge text-bg-danger">Expired</span>`;
                } else {
                    return `<span data-bs-toggle="tooltip" title="${data.days} day${s}">${data.diff}</span>`;
                }
            }},
            { data: null, render: (data) => `<span data-bs-toggle="tooltip" title="${data.date}">${data.date_raw}</span>` }
        ],
        order: [[order,"desc"]] as Order[],
        drawCallback: init_tooltips,
        initComplete: function() {
            //table.querySelector('th:nth-child('+(order+1)+')')?.classList.add('sorting_desc');
            //datatable.order([order,'desc']).draw();
        }
    });

    on('change', '#filter-type', (target: HTMLInputElement) => {
        datatable.ajax.reload();
    });

    on('change', '#filter-status', (target: HTMLInputElement) => {
        datatable.ajax.reload();
    });

    on('click','.js-trade-amount',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let amount = target.dataset.amount ?? "0";
        let completed = target.dataset.completed ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '1';
        input.value = completed;
        input.min = '0';
        input.max = amount;
        input.classList.add('form-control', 'form-control-sm', 'js-trade-amount-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true);

    on('focusout','.js-trade-amount-edit',(target : HTMLInputElement) => update_completed_from_table(target), true);
    on_keyup(13,'.js-trade-amount-edit',(target : HTMLInputElement) => update_completed_from_table(target));

    function update_completed_from_table(input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let completed = parseInt(input.value);
        get('?do=updateCompletedAmount', {id: id, completed: completed},(data : any) => {
            if(data) {
                notifier.success("Amount has been updated.");
            }
            datatable.ajax.reload();
        });
    }

    on('click','.js-trade-fee',(target : HTMLElement) => {
        let td = (target?.parentElement as HTMLElement);

        let fee = target.dataset.fee ?? "0";

        let input = document.createElement('input');
        input.type = 'number';
        input.step = '0.01';
        input.value = fee;
        input.min = '0';
        input.classList.add('form-control', 'form-control-sm', 'js-trade-fee-edit');
        input.setAttribute('data-id', target.getAttribute('data-id') ?? "0");

        td.innerHTML = '';
        td.appendChild(input);

        input.focus();
    },true);

    on('focusout','.js-trade-fee-edit',(target : HTMLInputElement) => update_fee_from_table(target), true);
    on_keyup(13,'.js-trade-fee-edit',(target : HTMLInputElement) => update_fee_from_table(target));

    function update_fee_from_table(input: HTMLInputElement) {
        let id = parseInt(input.getAttribute('data-id') ?? "0");
        let fee = input.value;
        get('?do=updateTradeFee', {id: id, fee: fee},(data : any) => {
            if(data) {
                notifier.success("Fee has been updated.");
            }
            datatable.ajax.reload();
        });
    }
}

function list_grouped() {
    let table = document.querySelector('.datatable[data-table="nw_trades_grouped"]') as HTMLElement;
    if(!table) {
        return;
    }

    let order = 0;
    let datatable = new DataTable('.datatable[data-table="nw_trades_grouped"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getTradesGrouped',
            data: function (data: TradesAjaxData, settings) {
                let type = document.getElementById('filter-type') as HTMLSelectElement;
                data.type = type.value;
                return data;
            }
        },
        columns: [
            { data: null, render: function (data, type, row) {
                return `<a href="/nw/item/${data.items_id}" class="text-decoration-none">${data.name}</a>` + crafting_link(data.crafting) + nwdb_link(data.nw_id);
            }},
            { data: null, render: function (data, type, row) {
                return data.type == 'sell' ? `<span class="badge text-bg-danger">Sell</span>` : `<span class="badge text-bg-success">Buy</span>`;
            }},
            { data: null, className: "text-end", render: function (data, type, row) {
                return `<span class="js-trade-amount" style="color: ` + data.completed_percent_color + `" data-id="${data.id}" data-amount="${data.amount}" data-completed="${data.completed}">${data.completed}/${data.amount}</span>`;
            }},
            { data: null, render: function (data, type, row) {
                return "";
            }},
            { data: null, render: function (data, type, row) {
                return gold(data.price);
            }},
            { data: null, render: function (data, type, row) {
                return gold(data.fee);
            }},
            { data: null, render: function (data, type, row) {
                return gold(data.profit,data.profit_raw_color);
            }},
            { data: null, render: function (data, type, row) {
                return data.completed > 0 ? gold(data.profit_per,data.profit_per_raw_color) : '-';
            }},
        ],
        order: [[order,"asc"]] as Order[],
        initComplete: function() {
            //table.querySelector('th:nth-child('+(order+1)+')')?.classList.add('sorting_asc');
            //datatable.order([order,'asc']).draw();
        }
    });

    on('change', '#filter-type', (target: HTMLInputElement) => {
        datatable.ajax.reload();
    });
}
